export default __webpack_public_path__ + "media/images/lp/About-pc-b6d06ac886172cd2c832cdd26704ba18.jpg";